import { getInstance } from '@ctct/distui-helpers';
import { observabilityAppService } from '@ctct/myaccount-utils-static';

class DistUI {
  public async getPartnerName() {
    const instance = await getInstance();

    return instance.getPartnerName();
  }

  public async getPartnerOwnerSummary() {
    const instance = await getInstance();

    return instance.getPartnerOwnerSummary();
  }

  public async goTo(direction: string, ...args) {
    const instance = await getInstance();

    return instance.goTo(direction, ...args);
  }

  public async track(config: { action: string }, params?: unknown) {
    try {
      const instance = await getInstance();

      return await instance.track(config, params);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    } catch (error) {
      observabilityAppService.notify(error, { message: 'Failed to track event', config, params });

      // Silently handle errors to prevent bubbling up
      return undefined;
    }
  }

  public async getIsSingleBilled() {
    const instance = await getInstance();

    return instance.isSingleBilled();
  }

  public async getUserId() {
    const instance = await getInstance();

    return instance.getUserId();
  }

  public async getPlanDetail() {
    const instance = await getInstance();

    return instance.getPlanDetail();
  }

  public async getAccountId() {
    const instance = await getInstance();

    return instance.getAccountId();
  }

  public async getRole() {
    const instance = await getInstance();

    return instance.getRole();
  }

  public async getIsTrialer() {
    const instance = await getInstance();

    return instance.isTrialer();
  }

  public async getIsCanceled() {
    const instance = await getInstance();

    return instance.isCanceled();
  }

  public async getIsSuspended() {
    const instance = await getInstance();

    return instance.isSuspended();
  }

  public async getProductAccount() {
    const instance = await getInstance();

    return instance.getProductAccount();
  }

  public async showCallSupport() {
    const instance = await getInstance();

    return instance.showCallSupport();
  }
}

export const distUI = new DistUI();
